interface ValueParams {
  value: any;
  setTime: number;
  expiryTime: number;
}

class UniLocalStorage {
  constructor() {}

  /**
   * 设置指定 key 的缓存
   * @param key
   * @param value
   * @param expiryTime 过期时间，单位为小时（h），会自动转换成毫秒
   */
  set(key: string, value: any, expiryTime?: number): void {
    try {
      if (value === undefined || value === null) return;
      let stringifyValue = '';
      if (expiryTime) {
        // 将小时转换为毫秒
        expiryTime = expiryTime * 60 * 60 * 1000;
        stringifyValue = JSON.stringify({
          value,
          setTime: Date.now(),
          expiryTime,
        });
      } else {
        stringifyValue = JSON.stringify(value);
      }
      // #ifdef H5
      window.localStorage.setItem(key, stringifyValue);
      // #endif

      // #ifndef H5
      uni.setStorageSync(key, stringifyValue);
      // #endif
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 获取指定 key 的缓存
   * @param key
   * @returns
   */
  get(key: string) {
    try {
      let parseValue: any = null;
      // #ifdef H5
      parseValue = window.localStorage.getItem(key);
      // #endif

      // #ifndef H5
      parseValue = uni.getStorageSync(key);
      // #endif

      if (!parseValue) return null;
      parseValue = JSON.parse(parseValue);
      if (parseValue?.setTime) {
        if (!this.isExpired(parseValue)) {
          return parseValue.value;
        } else {
          // #ifdef H5
          window.localStorage.removeItem(key);
          // #endif

          // #ifndef H5
          uni.removeStorageSync(key);
          // #endif
          return null;
        }
      }
      return parseValue;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 删除指定 key 的缓存
   * @param key
   */
  remove(key: string) {
    try {
      // #ifdef H5
      window.localStorage.removeItem(key);
      // #endif

      // #ifndef H5
      uni.removeStorageSync(key);
      // #endif
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 清除所有缓存
   */
  clear() {
    try {
      // #ifdef H5
      window.localStorage.clear();
      // #endif

      // #ifndef H5
      uni.clearStorageSync();
      // #endif
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 判断是否存在指定 key 的缓存
   * @param key
   * @returns
   */
  has(key: string): boolean {
    // #ifdef H5
    return !!window.localStorage.getItem(key);
    // #endif

    // #ifndef H5
    // return !!uni.getStorageSync(key);
    // #endif
  }

  /**
   * 判断缓存是否过期
   * @param value
   * @returns
   */
  private isExpired(value: ValueParams): boolean {
    return value.setTime + value.expiryTime <= Date.now();
  }
}

export const storage = new UniLocalStorage();
